<template>
	<div class="text-start roboto-flex-medium">
		<h2 class="mb-2 text-indigo-700 text-xl">🔧 P0002: Fuel Volume Regulator A Control Circuit Performance</h2>
		<p class="mb-4">Your car’s fuel control system is feeling… inconsistent. Not broken, just off. Like someone playing jazz with your fuel delivery 🎷⛽️.</p>
		<p class="mb-4">This code usually means the regulator is technically working — but not quite how the PCM expects. It’s sending fuel like a moody barista: sometimes too much, sometimes too little.</p>
		<p class="mb-4">Check wiring, connections, and maybe that regulator itself. This isn’t a hard failure, but your engine might be throwing shade on performance. Time to get it harmonized 🎛️.</p>
	</div>
</template>
